"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertKeyToTab = exports.hasItem = exports.normalizeTabs = exports.normalizeTab = exports.makeTab = exports.generateKeyFromTab = void 0;
const generateKeyFromTab = (tab) => {
    const { type, subtype } = tab;
    if (subtype)
        return [type, subtype].join('__');
    return type;
};
exports.generateKeyFromTab = generateKeyFromTab;
const makeTab = (type, subtype) => {
    let resultType = type;
    let resultSubtype = subtype;
    if (Array.isArray(type)) {
        resultType = type[0];
        if (type[1]) {
            resultSubtype = type[1];
        }
    }
    return Object.assign({ type: resultType }, (resultSubtype && { subtype: resultSubtype }));
};
exports.makeTab = makeTab;
const normalizeTab = (tab) => {
    if (typeof tab !== 'string')
        return tab;
    return (0, exports.makeTab)(tab);
};
exports.normalizeTab = normalizeTab;
const normalizeTabs = (tabs) => tabs === null || tabs === void 0 ? void 0 : tabs.map(tab => (0, exports.normalizeTab)(tab));
exports.normalizeTabs = normalizeTabs;
const hasItem = (list, item) => {
    const stringifiedList = JSON.stringify(list);
    const stringifiedTab = JSON.stringify(item);
    return stringifiedList.includes(stringifiedTab);
};
exports.hasItem = hasItem;
const convertKeyToTab = (key) => {
    const [type, subtype] = key.split('__');
    return (0, exports.makeTab)(type, subtype);
};
exports.convertKeyToTab = convertKeyToTab;
